import { FirehoseClient } from "@aws-sdk/client-firehose"
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers"

let region = "us-west-2"
let identityPoolId = "us-west-2:b3bd77e5-fb90-4dd8-9b11-11c5ccc4a36f"
let firehoseDeliveryStreamName = "guidebook_dev_metrics_stream"

if (process.env.REACT_APP_ENV === "production") {
  region = "us-east-1"
  identityPoolId = "us-east-1:2fd97604-f7a1-486d-ba9a-525d9c528756"
  firehoseDeliveryStreamName =
    "guidebook_production_metrics_ingestion_stream-fe"
} else if (process.env.REACT_APP_ENV === "staging") {
  region = "us-east-1"
  identityPoolId = "us-east-1:ef50705f-3384-435b-ada0-3ee608a255a4"
  firehoseDeliveryStreamName = "guidebook_staging_metrics_ingestion_stream-fe"
}

const credentials = fromCognitoIdentityPool({
  clientConfig: { region },
  identityPoolId: identityPoolId,
})

const firehoseClient = new FirehoseClient({
  region: region,
  credentials,
})

export { firehoseClient, firehoseDeliveryStreamName }
